/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as RoomingDataStoreActions from './rooming-data-store.actions';

import { Rooming } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'RoomingDataStore';

/* State interface */
export interface RoomingState {
  isLoading?: boolean;
  roomings?: Rooming[];
  activeRooming?: Rooming;
}

/* Initial values */
export const initialState: RoomingState = {
  isLoading: null,
  roomings: null,
  activeRooming: null,
};

export const reducer = createReducer(
  initialState,
  on(RoomingDataStoreActions.GetRoomings, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(RoomingDataStoreActions.GetRoomingsSuccessful, (state, action) => ({
    ...state,
    roomings: action.payload.roomings,
    isLoading: false,
  })),

  on(RoomingDataStoreActions.GetRoomingsFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(RoomingDataStoreActions.GetRoomingById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(RoomingDataStoreActions.GetRoomingByIdSuccessful, (state, action) => ({
    ...state,
    /* TODO: replace item by id from data array */
    isLoading: false,
  })),

  on(RoomingDataStoreActions.GetRoomingByIdFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(
    RoomingDataStoreActions.GetActiveRoomingWithRelationsById,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    RoomingDataStoreActions.GetActiveRoomingByIdWithRelationsSuccessful,
    (state, action) => ({
      ...state,
      activeRooming: action.payload.activeRooming,
      isLoading: false,
    }),
  ),

  on(
    RoomingDataStoreActions.GetActiveRoomingByIdWithRelationsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(RoomingDataStoreActions.CreateRooming, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(RoomingDataStoreActions.CreateRoomingSuccessful, (state, action) => ({
    ...state,
    roomings: [...(state.roomings ?? []), action.payload.rooming],
    isLoading: false,
  })),

  on(RoomingDataStoreActions.CreateRoomingFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(RoomingDataStoreActions.UpdateRooming, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(RoomingDataStoreActions.UpdateRoomingSuccessful, (state, action) => ({
    ...state,
    roomings: updateEntityInArray<Rooming>(
      action.payload.id,
      action.payload.data,
      state.roomings ?? [],
    ),
    isLoading: false,
  })),

  on(RoomingDataStoreActions.UpdateRoomingFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(RoomingDataStoreActions.DeleteRooming, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(RoomingDataStoreActions.DeleteRoomingSuccessful, (state, action) => ({
    ...state,
    roomings:
      state.roomings?.filter((item) => action.payload.id !== item.id) ?? [],
    isLoading: false,
  })),

  on(RoomingDataStoreActions.DeleteRoomingFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(RoomingDataStoreActions.ResetState, () => initialState),
);
